import React, { ReactNode } from 'react';
import { HoneyMoonContext } from './index';

interface PacoteDetailProviderProps {
  data: ViagemHoneyMoonPageDataType;
  children?: ReactNode;
}
const HoneyMoonProvider = ({ data, children }: PacoteDetailProviderProps) => {
  return <HoneyMoonContext.Provider value={{ data }}>{children}</HoneyMoonContext.Provider>;
};

export default HoneyMoonProvider;
